import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  icons:{
    iconfont:"mdi"
  },
  theme: {
    themes: {
      light: {
        primary: '#7052fb',
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
        purple: '#7052fb',
        'purple-variant': '#f2f3f8',
        pink: '#454EB0',
      },
      dark: {
        primary: '#7052fb',
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
        purple: '#7052fb',
        'purple-variant': '#f2f3f8',
        pink: '#454EB0',
      },
    }
  }
});
